import { Link } from 'react-router-dom'
import './AuthCard.css'
import Logo from '../../../assets/images/syamlogo.jpeg'

export default function AuthCard({
  children,
  allImg = [],
  headLogo,
  msgInput,
  title,
  title2,
  title3,
  description,
  navigateLink,
  pageTitle,
  bottomName,
  bottomImg,
  loading,
  signUp,
  bottomImgClass,
  topImgClass,
}) {
  return (
    <section>
      <div className="authCard-container">
        <div className="logo-fields justify-content-center">
          <div className='auth-card-shayam-logo'>
            <img src={Logo} alt="" />
          </div>
          <div className="welcome-text d-flex justify-content-center items-center flex-column">
            <h2>{title}</h2>
            <h2>{title2}</h2>
            <h2>{title3}</h2>

            <p className='text-center'>{description}</p>
          </div>
          <div className="row p-3 mt-10 justify-content-center">
            {allImg.map((item, idx) => (
              <div
                key={idx}
                className="col-12 col-sm-6 col-md-4 mb-4 d-flex justify-content-center"
              >
                <div className='img_container'
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    cursor: "pointer",
                    width: "300px",
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  }}
                >
                  <img
                    src={item}
                    alt={`logo-${idx}`}
                    className="img-fluid"
                    style={{ maxHeight: "70px", padding: "5px" }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="input-fields">

          <div className='auth-card-shayam-logo'>
            <img src={Logo} alt="" />
          </div>

          <div className="input-logo" >
            <img src={headLogo} className={topImgClass} alt="logo" />
          </div>
          <div className="input-text">
            <h2>{pageTitle}</h2>
            <p className='px-3'>
              {msgInput}
              <span className='ml-3'>
                <Link to={navigateLink} className="signup-link">
                  {signUp}
                </Link>
              </span>
            </p>

            <div className="input-arrow">
              {children}
            </div>

            <div className="mt-5 bottom-logo">
              <img src={bottomImg} className={bottomImgClass} alt="bottom-logo" />
              <p>{bottomName}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

